import { render } from "./loader.vue?vue&type=template&id=7284a40e&scoped=true"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=7284a40e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7284a40e"]])

export default __exports__